import { Supplier } from "./supplier";
import { Contact } from "./contact";

export class SupplierContactId{
    supplierId?: number;
    contactId?: number;
}
export class SupplierContact{
    id:SupplierContactId = new SupplierContactId();
    supplier?: Supplier;
    contact: Contact = new Contact();
    createdAt?: Date = new Date();
}
